/*
このスクリプトにはjQueryライブラリが必要です。
ボディタグがTheme.Liquidで終了する直前にこのファイルを追加してください。
*/

$(document).ready(function(){
  /// メイン検索入力
  $('#pageheader .search-box input[type="text"]').bind('focusin focusout', function(e){
      $(this).closest('.search-box').toggleClass('focus', e.type == 'focusin');
  });


  /// ライブ検索
  let searchTimeoutThrottle = 500;
  let searchTimeoutID = -1;
  let currReqObj = null;
  let resultsBox = $('.results-box');

  $('#pageheader .search-box input[type="text"]').bind('keyup change', function(){

    // 検索の文字列が２文字より多くて、前回のワードと違う時
    if($(this).val().length > 2 && $(this).val() != $(this).data('oldval')) {
          //前の値をリセットします
          $(this).data('oldval', $(this).val());

          // 通信中のAjaxリクエストを中断
          if(currReqObj != null) currReqObj.abort();

          // 以前の検索を中断
          clearTimeout(searchTimeoutID);

          let searchForm = $(this).closest('form');

          //検索キーワード
          let term = searchForm.find('input[name="q"]').val();

          //検索ページへのURL
          let linkURL = searchForm.attr('action') + '?type=product&q=' + term;

          searchTimeoutID = setTimeout(function(){
              currReqObj = $.ajax({
                url: searchForm.attr('action'),
                data: {
                  type: 'product',
                  view: 'json',
                  q: term,
                },
                dataType: "json",
                success: function(data){
                  currReqObj = null;
                  if(data.results_total == 0) {
                      // 一致する商品がない時
                      resultsBox.html('<div class="note">'+ '一致する商品はありません。' +'</div>');
                  } else {
                    // 一致する商品がある時
                    resultsBox.empty();
                      $.each(data.results, function(index, item){
                        let $row = $('<a></a>').attr('href', item.url);
                        $row.append('<div class="img"><img src="' + item.thumb + '" /></div>');
                        $row.append('<div class="d-title">'+item.title+'</div>');
                        resultsBox.append($row);
                      });

                      // 全ての結果を見るボタン
                      resultsBox.append('<a href="' + linkURL + '" class="note">対象の商品を見る</a>');
                  }
                }
              });
          }, searchTimeoutThrottle);

      } else if ($(this).val().length <= 2) {
          //キーワードが２以下の時にサジェストの内容を削除する
          resultsBox.empty();
      }
  }).attr('autocomplete', 'off').data('oldval', '').bind('focusin', function(){
      // 再フォーカスされた時にサジェストを表示します
      resultsBox.fadeIn(200);
  }).bind('click', function(e){
      //クリックして、ボディが[イベント]をクリックしないようにします
      e.stopPropagation();
  });

  //サジェスト以外をクリックした時に、サジェストを非表示にする
  $('body').bind('click', function(){
      resultsBox.fadeOut(200);
  });


  //検索するボタンをクリックした時の挙動
  $('.search-form, #search-form').on('submit', function(e){
    e.preventDefault();
    let term = $(this).find('input[name="q"]').val();
    let linkURL = $(this).attr('action') + '?type=product&q=' + term;
    window.location = linkURL;
  });

});